<template>
    <ValidationObserver ref="form">
        <div class="box box-w-1" @keyup.enter="sendEmail">
            <div class="box-inner">
                <h2>Forgot your password?</h2>
                <div class="text-center">
                    <p>Please Enter your Email below and we'll send password reset instructions to the email address in
                        your profile</p>
                </div>
                <div class="form">
                    <div class="row">

                        <ValidationProvider name="Email" rules="email|required" v-slot="{errors}" class="col-lg-12">
                            <div class="form-group form-group-1">
                                <input type="email" v-model="form.email" class="form-control"
                                       placeholder="Email Address">
                                <FormError :error="errors[0]" name="Email"></FormError>
                            </div>
                        </ValidationProvider>

                    </div>
                    <div class="row">
                        <div class="col-sm-6 mb-4 mb-sm-0">
                            <a href="/master-admin/login" class="btn btn--outline-primary w-100">Cancel</a>
                        </div>
                        <div class="col-sm-6">
                            <button class="btn btn--secondary w-100" @click="sendEmail">Send Email</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
import LoginFormService from "../services/LoginFormService";

export default {
    name: 'PasswordRecoveryForm',
    data() {
        return {
            form: {
                email: '',
            }
        }
    },
    methods: {
        sendEmail() {
            (async () => {
                const valid = await this.$refs.form.validate();

                if (!valid) {
                    this.$showValidationErrorMessage();
                    return;
                }
                const result = LoginFormService.resetPassword(this.form)
                    .then(response => {
                        if (response.status === 200) {
                            this.$showSuccessMessage('We sent instruction on your email.', 'Success!')
                            window.location.href = `/master-admin/login`;
                        }
                    })
                    .catch(error => {
                        console.error('Oops, general error');
                        this.$showErrorMessage(`Something went wrong. Please try again`);

                    });

            })();
        }
    }

}

</script>

<style scoped>

</style>
